module.exports = __webpack_public_path__ + "icon_person_add-44d0a8dfa7dce95be5f6e3cfe0cdd133.png";